export const GEOFENCING_ERROR_ALERT_ID = "GEOFENCING_ERROR_ALERT_ID";
export const GEOLOCATION_PERMISSION_NOTICE_ID = "GEOLOCATION_PERMISSION_NOTICE_ID";
export const WAGERING_BLOCK_NOTICE_ID = "WAGERING_BLOCK_NOTICE_ID";
export const GTM_GEOFENCING_ALERT_SUB_AREA = "GeofencingAlert";
export const GEOLOCATION_DEFAULT_LOCATION_ID = "default";

export const GEOFENCING_TRANSLATION_KEYS = {
	generalClose: "general.close",
	generalContactCustomerSupport: "general.contact-customer-support",
	errorTitle: "geofencing.error.title",
	errorText: "geofencing.error.text",
	disabledText: "geofencing.disabled.text",
	locationAccessTitle: "geofencing.location-access.title",
	locationAccessText: "geofencing.location-access.text",
	ontarioRestricted: "geofencing.ontario-restricted",
	readMore: "geofencing.read-more",
	redirectButtonText: "geofencing.redirect-button.text",
	invalidPosition: "geofencing.invalid-position",
	invalidCountryAccess: "geofencing.invalid-country-access",
	generalError: "geofencing.general-error",
	multipleTriesError: "geofencing.multiple-tries-error",
	serverError: "geofencing.server-error",
	vpnOrProxyError: "geofencing.vpn-or-proxy-error",
};
